import { useMemo } from 'react'
import { HamburgerItemComponent, HamburgerPlugin, TreeNodeOrNodeSlug } from 'react-common'
import { useTranslation } from 'react-i18next'
import { LEARN_CATALOG_SLUG } from '@/features/layout/LayoutMain/constants'
import { TenantLogoPluginComponent } from '../TenantLogoPlugin/TenantLogoPluginComponent'
import { useStencilNavigation } from '../useStencilNavigation'

export const PublicCatalogHamburgerContainer = () => {
  const { t } = useTranslation()
  const { activeSlug, setActiveSlug } = useStencilNavigation()

  const hamburgerItems = useMemo(
    (): TreeNodeOrNodeSlug[] => [
      {
        url: '/learn/open-catalog',
        name: t('catalogList.heading'),
        icon_id: 'CatalogBoldStroke',
        slug: LEARN_CATALOG_SLUG,
      },
    ],
    [t],
  )
  return (
    <HamburgerPlugin logo={<TenantLogoPluginComponent mode={'public'} link="/open-catalog" isHamburger />}>
      {hamburgerItems.map((item) => {
        // this is for skip type-check. since TreeNodeOrNodeSlug = .. | string, below HamburgerItemComponent will throw error
        // but for hamburgerItems, we are sure that it will not be string
        if (typeof item === 'string') {
          return null
        }

        return (
          <HamburgerItemComponent
            key={item.name}
            item={{
              url: item.url,
              name: item.name,
              icon_id: item.icon_id,
              slug: item.slug,
              isSection: false,
              parentSlug: null,
            }}
            isActive={activeSlug === item.slug}
            onClick={() => setActiveSlug(item.slug)}
          />
        )
      })}
    </HamburgerPlugin>
  )
}
